import ChargesList from "../ChargesList";
import AddCharges from "../AddCharges";
import { useEffect, useState } from "react";
import Modal from "@/common/elements/Modal";
import { useSelector } from "react-redux";
import { v4 as uuidV4 } from "uuid";
import ChargesBailRecordsDetails from "./ChargesBailRecordsDetails";
import { StyledSectionHeading } from "@/common/styles";
import ChargesBailPaymentsDetails from "./ChargesBailPaymentsDetails";
import { hasCheckSecurity, isNonEmptyVariable } from "@/util/common_function";
import { Arbitrary_Names, Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";

const BookingsCharges = ({ bookingChargeRef,startingPoint }) => {
  const { bookings, bookingsFieldsEnabled } = useSelector(
    (state) => state?.bookings
  );
  const [chargesData, setChargesData] = useState([]);
  const [bookingBails, setBookingBails] = useState([]);
  const [bookingPayments, setBookingPayments] = useState([]);
  const [showAddCharges, setShowAddCharges] = useState(false);
  const fullSearch = useSelector(state => state.fullSearch);

  useEffect(() => {
    if (bookings?.charges?.length || (fullSearch && bookings?.bookingBailPayments?.length)) {
      let data = JSON.parse(JSON.stringify(bookings?.charges));
      data = data?.map((c) => {
        return {
          ...c,
          uuid: isNonEmptyVariable(c?.uuid) ? c?.uuid : uuidV4(),
          controllingCharge: c?.controllingCharge || false,
        };
      });
      setChargesData(data);

      const bailData = [];

      bookings?.bookingBails?.forEach((a) => {
        const obj = {
          ...a,
          bookingBailUuid: isNonEmptyVariable(a?.bookingBailUuid)
            ? a?.bookingBailUuid
            : uuidV4(),
        };

        bailData.push(obj);
      });

      setBookingBails(() => bailData);

      const bailPayments = [];
      bookings?.bookingBailPayments?.forEach((bp, index) => {
        const obj = {
          ...bp,
          id: index + 1,
          bailPaymentsUuid: isNonEmptyVariable(bp?.bailPaymentsUuid)
            ? bp?.bailPaymentsUuid
            : uuidV4(),
          bookingBailPaymentBails: bp?.bookingBailPaymentBails?.map((bbpb) => {
            const bb = bookings?.bookingBails?.find(
              (bb) => bb?.bookingBailID === bbpb?.bookingBailID
            );
            if (isNonEmptyVariable(bb)) {
              return {
                ...bbpb,
                ...bb,
              };
            }
          }),
        };

        bailPayments.push(obj);
      });

      setBookingPayments(() => bailPayments);
    } else {
      setChargesData([]);
      setBookingPayments([]);
      setBookingBails([]);
    }
  }, [bookings]);

  const clickAddCharges = () => {
    setShowAddCharges(true);
  };

  return (
    <>
      {
        hasCheckSecurity(
          Security_Types.functionality,
          Entity_types.arbitary,
          LABELS_CAPITAL.VIEW,
          Arbitrary_Names.divArrestCharges
        ) &&
        (
          <ChargesList
            chargesData={chargesData}
            switchToAddCharges={clickAddCharges}
            bookingBails={bookingBails}
            startingPoint={startingPoint}
          />
        )
      }
      {
        hasCheckSecurity(
          Security_Types.functionality,
          Entity_types.arbitary,
          LABELS_CAPITAL.VIEW,
          Arbitrary_Names.divArrestChargesBond
        ) &&
        (
          <>
            <StyledSectionHeading marginTop="25px">
              <span>Bail Records </span>
            </StyledSectionHeading>
            <ChargesBailRecordsDetails startingPoint={startingPoint} />

            <StyledSectionHeading marginTop="25px">
              <span>Bail Payments </span>
            </StyledSectionHeading>
            <ChargesBailPaymentsDetails
              chargesData={chargesData}
              bookingBailsData={bookingBails}
              bookingPayments={bookingPayments}
              startingPoint={startingPoint}
            />
          </>
        )
      }
    </>
  );
};
export default BookingsCharges;
